import React from "react";
import useStore from "../../../useStore";
import { useToast } from "../../../Contexts/Toast/toast.provider";
import { useModal } from "../../../Hooks/useModal";
import { DIAS } from "../../../Constants/Admin";
import { PROMO_ITEMS } from "../../../Constants/PromoItems";
import FormPromo from "./FormPromo";
import Confirmar from "./Confirmar";
import { Switch, IconButton } from "./Campos";

const AdminPromos = () => {
  const showToast = useToast();
  const { abrirModal } = useModal();
  const { promos, guardarPromo, eliminarPromo } = useStore();
  const hoy = DIAS[new Date().getDay()];

  // Ordenadas de lunes a domingo
  const ordenSemana = (d) => (DIAS.indexOf(d) + 6) % 7;
  const lista = [...promos].sort((a, b) => ordenSemana(a.dia) - ordenSemana(b.dia));
  const diasSinPromo = DIAS.filter((d) => !promos.some((p) => p.dia === d && p.activa !== false));

  const nueva = () =>
    abrirModal({
      title: "Nueva promo",
      size: "medium",
      contenido: (cerrar) => <FormPromo cerrar={cerrar} />,
    });

  const editar = (promo) =>
    abrirModal({
      title: `Promo del ${promo.dia}`,
      size: "medium",
      contenido: (cerrar) => <FormPromo promo={promo} cerrar={cerrar} />,
    });

  const toggle = async (promo) => {
    const activa = promo.activa === false;
    const r = await guardarPromo({ activa }, promo.promoId);
    showToast(r.ok ? "success" : "error", r.ok ? (activa ? `Promo del ${promo.dia} activa 🔥` : `Promo del ${promo.dia} apagada`) : r.message);
  };

  const eliminar = (promo) =>
    abrirModal({
      title: "Eliminar promo",
      size: "small",
      contenido: (cerrar) => (
        <Confirmar
          mensaje={`¿Eliminar la promo del ${promo.dia}?`}
          detalle="Si solo es por esta semana, mejor apágala."
          cerrar={cerrar}
          onConfirm={async () => {
            const r = await eliminarPromo(promo.promoId);
            showToast(r.ok ? "success" : "error", r.ok ? "Promo eliminada 🗑️" : r.message);
            return r.ok;
          }}
        />
      ),
    });

  return (
    <section className="pp-panel">
      <div className="pp-toolbar">
        <p className="pp-toolbar-texto">
          {diasSinPromo.length ? (
            <>Días sin promo: <strong>{diasSinPromo.join(", ")}</strong></>
          ) : (
            "Todos los días tienen promo 🎉"
          )}
        </p>
        <div className="pp-toolbar-botones">
          <button type="button" className="pp-btn" onClick={nueva}>
            <i className="bi bi-plus-lg" /> Promo
          </button>
        </div>
      </div>

      {!lista.length && <p className="pp-vacio">Aún no hay promos. Crea la primera.</p>}

      <div className="pp-promos">
        {lista.map((p) => {
          const apagada = p.activa === false;
          return (
            <article key={p.promoId} className={`pp-promo ${apagada ? "oculta" : ""} ${p.dia === hoy ? "hoy" : ""}`}>
              <header>
                <h3>
                  {p.dia}
                  {p.dia === hoy && <span className="pp-badge pp-badge-dorado">Hoy</span>}
                  {apagada && <span className="pp-badge">Apagada</span>}
                </h3>
                <span className="pp-promo-precio">${p.precio}</span>
              </header>
              <div className="pp-promo-fotos">
                {(p.incluye || []).map((k, i) =>
                  PROMO_ITEMS[k] ? <img key={`${k}-${i}`} src={PROMO_ITEMS[k].img} alt={PROMO_ITEMS[k].label} title={PROMO_ITEMS[k].label} /> : null
                )}
              </div>
              <p className="pp-promo-desc">{p.descripcion}</p>
              <footer>
                <Switch compacto label={apagada ? "Apagada" : "Activa"} checked={!apagada} onChange={() => toggle(p)} />
                <div className="pp-botonera">
                  <IconButton icon="bi-pencil" title="Editar" onClick={() => editar(p)} />
                  <IconButton icon="bi-trash3" title="Eliminar" variante="peligro" onClick={() => eliminar(p)} />
                </div>
              </footer>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default AdminPromos;
